import React from 'react'
import ReactBootstrapSlider from 'react-bootstrap-slider'

import { translate } from 'react-i18next'
import { withRouter } from 'react-router-dom'

import { Loader, TextInput, Form } from '../../../UI'
import { validateRequired } from '../../../../libs/validation'
import { graphql, compose } from 'react-apollo'

import UPDATE_LOCAL_TOUR from '../../../../graphql/ActivitySteps/UpdateLocalTourLengthPrice.graphql'
import { NotificationManager } from 'react-notifications';

class LengthPrice extends React.Component {
  state = {
    saving: false,
    privateTour: '150',
    perPerson: '100',
    hours: 2
  }

  componentWillMount() {
    const { currentSteps } = this.props
    let groupRange
    if (currentSteps.minGroupSize && currentSteps.maxGroupSize) {
      groupRange = [currentSteps.minGroupSize, currentSteps.maxGroupSize]
    } else {
      groupRange = [2, 10]
    }
    this.setState({
      groupRange: groupRange,
      minGroupSize: currentSteps.minGroupSize || 2,
      maxGroupSize: currentSteps.maxGroupSize || 10,
      estimatedDurationHours: currentSteps.estimatedDurationHours || '',
      privateTourPrice: currentSteps.privateTourPrice || '',
      groupPrice: currentSteps.groupPrice || '',
      currency: currentSteps.currency || 'USD'
    })
  }

  getRange = event => {
    let minGroupSize, maxGroupSize
    ;[minGroupSize, maxGroupSize] = event.target.value
    this.setState({
      groupRange: event.target.value,
      minGroupSize: minGroupSize,
      maxGroupSize: maxGroupSize
    })
  }

  handleChange = e => {
    this.setState({
      currency: e.target.value
    })
  }

  handleSubmit = values => {
    const { data, updateLocalTour, updateSteps, history } = this.props

    this.setState({
      saving: true
    })

    updateLocalTour({
      variables: {
        id: this.props.currentSteps.id,
        estimatedDurationHours: parseInt(values.estimatedDurationHours),
        privateTourPrice: parseInt(values.privateTourPrice),
        minGroupSize: this.state.minGroupSize,
        maxGroupSize: this.state.maxGroupSize,
        groupPrice: parseInt(values.groupPrice),
        currency: this.state.currency
      }
    }).then(() => {
      this.setState(
        {
          saving: false
        },
        () => {
          updateSteps()
          NotificationManager.success('Lengs changed', 'Success', 5000)
          if (data.allLocalTours && data.allLocalTours[0]) {
            history.push(`/activity-steps/${data.allLocalTours[0].id}/event-dates`)
          } else {
            history.push('/activity-steps/event-dates')
          }
        }
      )
    }).catch(err=>NotificationManager.error('Error while updating length', 'Error', 5000))
  }

  render() {
    const { t, loading } = this.props
    const { saving, privateTour, hours, perPerson } = this.state

    if (loading) {
      return <Loader showLoader={true} />
    }

    return (
      <div className="steps-screen__form step-form faded-container">
        <div className="steps-screen__form-title">{t('length_price')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger steps-submit-btn"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <div className="form-section">
              <div className="form-group steps-screen__input-row">
                <div className="steps-screen__form-subtitle">{t('tour_length')}</div>
                <div className="small-input-wrapper">
                  <TextInput
                    type="text"
                    id="estimatedDurationHours"
                    extraClass="event__form-input"
                    validationFuncs={[validateRequired]}
                    initialValue={this.state.estimatedDurationHours}
                    placeholder={'' + hours}
                  />
                </div>
                <label htmlFor="activity-amount" className="event__form-label control-label mb-0">
                  {t('hours_day')}
                </label>
              </div>
            </div>

            <div className="form-section group-slider">
              <div className="steps-screen__form-subtitle">{t('group_size')}</div>

              <ReactBootstrapSlider
                value={this.state.groupRange}
                max={40}
                min={1}
                step={1}
                orientation="horizontal"
                slideStop={this.getRange}
              />

              <div className="range">
                <span className="range-value">1</span>
                <span className="range-value right-value">40</span>
              </div>
            </div>

            <div className="form-section">
              <div className="steps-screen__form-subtitle">{t('tour_price')}</div>
              <div className="form-subtitle" style={{ paddingBottom: 25 }}>
                {t('tour_price_description')}
              </div>

              <div className="form-group row">
                <div className="col-md-6 col-sm-6 price-input no-padding-right">
                  <div className="steps-screen__input-row">
                    <label htmlFor="activity-amount" title={t('price_per_person')} className="event__form-label control-label mb-0">
                      {t('price_per_person')}
                    </label>
                    <TextInput
                      type="text"
                      id="groupPrice"
                      extraClass="event__form-input"
                      validationFuncs={[validateRequired]}
                      initialValue={this.state.groupPrice}
                      placeholder={perPerson}
                    />
                  </div>
                </div>

                <div className="col-md-6 col-sm-6 price-input ">
                  <div className="steps-screen__input-row">
                    <label htmlFor="activity-currency" className="event__form-label control-label mb-0">
                      {t('private_tour')}
                    </label>
                    <TextInput
                      type="text"
                      id="privateTourPrice"
                      extraClass="event__form-input"
                      validationFuncs={[validateRequired]}
                      initialValue={this.state.privateTourPrice}
                      placeholder={privateTour}
                    />
                  </div>
                </div>
              </div>

              <div className="row form-group">
                <div className="col-md-6 col-sm-6 price-input ">
                  <div className="steps-screen__input-row">
                    <label htmlFor="activity-currency" className="event__form-label control-label mb-0">
                      {t('currency_label')}
                    </label>
                    <select
                      id="activity-currency"
                      value={this.state.currency}
                      className="form-control event__form-input"
                      onChange={e => this.handleChange(e)}
                    >
                      <option value="USD">USD</option>
                      <option value="EUR">EUR</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

const enhance = compose(
  translate('activity_steps'),
  graphql(UPDATE_LOCAL_TOUR, {
    name: 'updateLocalTour'
  }),
  withRouter
)

export default enhance(LengthPrice)



// WEBPACK FOOTER //
// src/components/ActivitySteps/Steps/TimesLocation/LengthPrice.jsx